<div class="teaser-header">
  <app-back-button [title]="pageTitle" (backClicked)="gotoDashboard()"> </app-back-button>
  <div class="button-group">
    <button
      *ngIf="teaserComponent === 'sensordaten'"
      id="button-onboard"
      class="btn btn-outline-primary"
      [class.onboard-sensor-button-hidden]="isOnboardingButtonHidden$ | async"
      (click)="onboardSensor()"
    >
      <span class="fa fa-plus-circle"></span>
      {{ 'module.sensorData.teaser.buttonOnboard' | translate }}
    </button>
    <button id="button-edit" class="btn btn-outline-primary" [class.edit-teaser-button-hidden]="isEditTeaserButtonHidden" (click)="redirectToEditor()">
      <span class="fa fa-pencil"></span>
      {{ 'teaser.buttonEdit' | translate }}
    </button>
    <app-webshop-button></app-webshop-button>
  </div>
</div>

<div class="teaser" *ngIf="this.configuration$ | async">
  <div class="teaser-top">
    <app-carousel [assets]="teaserAssets" [baseURL]="baseURL" class="teaser-carousel"> </app-carousel>
  </div>
  <div class="teaser-bottom"></div>
  <div class="advantages">
    <div class="description-container">
      <h1>{{ teaserTitle }}</h1>
      <div>
        <h5 [innerHtml]="teaserDescription" class="desc"></h5>
      </div>
      <div class="button-container">
        <div class="button-container-main">
          <button id="button-send-email" class="btn btn-outline-primary" (click)="redirectToContact()">
            <span class="fa fa-envelope"></span>
            {{ this.teaserButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
